import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { MsalService } from '@azure/msal-angular';

@Injectable()
export class CreateUserService {

  constructor(
    private httpClient: HttpClient,
    private common: DatabaseCacheService,
    private msalService: MsalService,
  ) { }

  createUser(postBody) {
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = new HttpHeaders({'Content-Type': 'application/json'  })
      .set("loginUserId", loginUserId);

    let sectionId = this.common.getSelectedSection().sectionId;
    // this.storeAuth.getSection().subscribe((v) => {
    //   if (!v) {
    //     this.sectionId = localStorage.getItem('gokuri.sectionId');
    //   } else {
    //     this.sectionId = v;
    //   }
    // });

    return this.httpClient.post(`${apiConfig.uri}/licence/${sectionId}/users`, postBody, {headers : headers});
  }

}
